export default __webpack_public_path__ + "static/media/Esso=Imperial Oil.b40b30e6.png";